export const worksheets = [
  {
    id: "ckd8bdh2g00043g5ngye8airl",
    display_date: "2020-08-04",
    title: "Write-Pair-Share",
    url: "https://media.newsela.com/article_media/extra/2017-10-write-pair-share.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.987Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2020/07/30/2017-10-write-pair-share.jpg",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2020/07/30/2017-10-write-pair-share.jpg?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckd8bs9u000053g5nxgois6cb",
    display_date: "2020-08-04",
    title: "Web Chart",
    url: "https://media.newsela.com/article_media/extra/2-2018-Web-Chart.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2020/07/30/2-2018-Web-Chart.jpg",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2020/07/30/2-2018-Web-Chart.jpg?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckd8c99qq00063g5n5c3ufjak",
    display_date: "2020-08-04",
    title: "I See, I Think, I Wonder",
    url: "https://media.newsela.com/article_media/extra/ISee2CIThink2CIWonder.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2020/07/30/ISee2CIThink2CIWonder.jpg",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2020/07/30/ISee2CIThink2CIWonder.jpg?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckdah7gk000073g5ogyu14tvk",
    display_date: "2020-08-04",
    title: "Connect-Extend-Challenge",
    url: "https://media.newsela.com/article_media/extra/Connect-Extend-Challenge.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2020/07/31/Connect-Extend-Challenge.jpg",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2020/07/31/Connect-Extend-Challenge.jpg?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckit94g4w000s3e59goc6m4cn",
    display_date: "2023-08-31",
    title: "Connect-Extend-Challenge (for video)",
    url: "https://media.newsela.com/article_media/extra/Connect-Extend-Challenge-video.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2020/12/17/Screen%20Shot%202020-12-17%20at%201.44.07%20PM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2020/12/17/Screen%20Shot%202020-12-17%20at%201.44.07%20PM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckjxdmerg00013g5pkluhxaqr",
    display_date: "2021-03-15",
    title: "Venn Diagram",
    url: "https://media.newsela.com/article_media/extra/2017-10-Venn-Diagram.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/01/14/Screen%20Shot%202021-01-14%20at%204.40.41%20PM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/01/14/Screen%20Shot%202021-01-14%20at%204.40.41%20PM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckkgyqvky00203g5qnumwrjxv",
    display_date: "2023-08-31",
    title: "Accountable Talk Sentence Stems",
    url: "https://media.newsela.com/article_media/extra/Accountable_Talk_Stems.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/01/28/Screen%20Shot%202021-01-28%20at%209.39.34%20AM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/01/28/Screen%20Shot%202021-01-28%20at%209.39.34%20AM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckkopiny300213a5q80kkjft1",
    display_date: "2023-08-31",
    title: "Blog Post Planner",
    url: "https://media.newsela.com/article_media/extra/Blog_Post_Planner.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/03/Blog%20Post%20Planner.JPG",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/03/Blog%20Post%20Planner.JPG?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckkots8uh004o3a5q516l7ka7",
    display_date: "2023-08-31",
    title: "Timeline (blank)",
    url: "https://go.newsela.com/rs/628-ZPE-510/images/4.14.19%20Blank.Timeline.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/03/Timeline.JPG",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/03/Timeline.JPG?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckkpncom5003s445yj4cpefz2",
    display_date: "2023-08-30",
    title: "KWL Chart",
    url: "https://media.newsela.com/article_media/extra/2017-11-6-KWL-Chart.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/03/Screenshot%202021-02-03%20at%2011.31.33%20AM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/03/Screenshot%202021-02-03%20at%2011.31.33%20AM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckkxf5ml1005h3a5q2unnpkia",
    display_date: "2023-08-31",
    title: "Timeline Activity",
    url: "https://media.newsela.com/article_media/extra/TimelineWorksheet.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/09/Timeline.JPG",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/09/Timeline.JPG?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckkximr0g00bh3a5qwofxlrqq",
    display_date: "2023-08-31",
    title: "3 Column Chart",
    url: "https://media.newsela.com/article_media/extra/4.12.193-column-chart2020-02-25-01-01-53.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/09/3%20Column%20Chart.JPG",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/09/3%20Column%20Chart.JPG?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckkzj6ezs000u445y2ylcu94f",
    display_date: "2021-03-15",
    title: "Write Your Own Hook",
    url: "https://docs.google.com/document/d/1AJ0torCJcV6MI-nVFopL4BgAQh27FPPchk3G8gcuhBY/edit",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/10/Screenshot%202021-02-10%20at%209.31.52%20AM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/10/Screenshot%202021-02-10%20at%209.31.52%20AM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckkzkxg5g001l445y29hsev8b",
    display_date: "2021-03-15",
    title: "Reading and Writing for Change",
    url: "https://media.newsela.com/article_media/extra/Reading_Writing_for_Change.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/10/Screenshot%202021-02-10%20at%2010.23.05%20AM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/10/Screenshot%202021-02-10%20at%2010.23.05%20AM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckkzkxij9001m445ydrqa3t04",
    display_date: "2021-03-15",
    title: "Parts of a Letter",
    url: "https://media.newsela.com/article_media/extra/Part_of_a_Letter_Organizer_for_Reading_Writing_for_Change.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/10/Screenshot%202021-02-10%20at%2010.23.54%20AM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/10/Screenshot%202021-02-10%20at%2010.23.54%20AM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckkzlf5qq002j445yhiq9sr6f",
    display_date: "2021-03-15",
    title: "Research Essay Outline",
    url: "https://media.newsela.com/article_media/extra/NewselaEssayOutline.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/10/Screenshot%202021-02-10%20at%2010.34.18%20AM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/10/Screenshot%202021-02-10%20at%2010.34.18%20AM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckkzofdc4003i445y8hoopo9x",
    display_date: "2021-03-15",
    title: "Speech Analysis",
    url: "https://media.newsela.com/article_media/extra/2017-10-SpeechAnalysis.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/10/Screenshot%202021-02-10%20at%2012.01.33%20PM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/10/Screenshot%202021-02-10%20at%2012.01.33%20PM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckkzpo9mr0003445y4ew85ik2",
    display_date: "2023-08-31",
    title: "Self-Reflection",
    url: "https://media.newsela.com/article_media/extra/Self_Reflection.docx.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/10/Screenshot%202021-02-10%20at%2012.35.27%20PM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/10/Screenshot%202021-02-10%20at%2012.35.27%20PM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckl14z2i7001g445y6l8mluzh",
    display_date: "2023-08-31",
    title: "Triple Venn Diagram",
    url: "https://media.newsela.com/article_media/extra/10.3.19_Triple.Venn.Diagram.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/11/Screenshot%202021-02-02%20at%202.00.06%20PM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/11/Screenshot%202021-02-02%20at%202.00.06%20PM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckl1870l60060445ynbgl6tjs",
    display_date: "2021-03-15",
    title: "Blank Argumentative Organizer",
    url: "https://docs.google.com/drawings/d/1TgIL64EQl7sdDo4lJDBt3W7BuYDKe8oZePvySE7AXTc/edit",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/11/Screenshot%202021-02-11%20at%201.59.28%20PM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/11/Screenshot%202021-02-11%20at%201.59.28%20PM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "ckl194xds006d445y6p2i1vno",
    display_date: "2021-03-15",
    title: "Structure and Purpose",
    url: "https://media.newsela.com/article_media/extra/StructureandPurpose.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/11/Screenshot%202021-02-11%20at%202.24.49%20PM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/11/Screenshot%202021-02-11%20at%202.24.49%20PM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cklb8fne9003b445yij3ewccf",
    display_date: "2021-08-25",
    title: "Jigsaw Group Activity",
    url: "https://media.newsela.com/article_media/extra/NewselaJigsaw2.1.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/18/Screenshot%202021-02-18%20at%202.04.03%20PM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/18/Screenshot%202021-02-18%20at%202.04.03%20PM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cklb8fp32003c445y15uygxhi",
    display_date: "2021-08-25",
    title: "Plot Diagram",
    url: "https://media.newsela.com/article_media/extra/PlotDiagram.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/18/Screenshot%202021-02-18%20at%2011.49.54%20AM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/18/Screenshot%202021-02-18%20at%2011.49.54%20AM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cklb8fqog003d445yuon72n7y",
    display_date: "2021-08-25",
    title: "Storyboard",
    url: "https://media.newsela.com/article_media/extra/Storyboard.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/18/Screenshot%202021-02-18%20at%2011.50.50%20AM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/18/Screenshot%202021-02-18%20at%2011.50.50%20AM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cklb8fsf4003e445ynfgqvjvp",
    display_date: "2021-08-25",
    title: "Flowchart",
    url: "https://media.newsela.com/article_media/extra/2018-10-4_Flowchart.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/18/Screenshot%202021-02-18%20at%202.05.53%20PM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/18/Screenshot%202021-02-18%20at%202.05.53%20PM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cklbcmnlc003w445y974phqle",
    display_date: "2023-08-31",
    title: "Research Notes",
    url: "https://media.newsela.com/article_media/extra/Research_Notes.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/18/Screenshot%202021-02-18%20at%204.07.05%20PM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/18/Screenshot%202021-02-18%20at%204.07.05%20PM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cklbcmsly003y445yrzgrqi64",
    display_date: "2023-09-07",
    title: "Comparing Multiple Sources",
    url: "https://media.newsela.com/article_media/extra/4.18.18.ComparingMultipleSources.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/18/Screenshot%202021-02-18%20at%204.09.05%20PM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/18/Screenshot%202021-02-18%20at%204.09.05%20PM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cklbcmwf8003z445yk76x5ovj",
    display_date: "2023-09-07",
    title: "Paired Text Analysis",
    url: "https://media.newsela.com/article_media/extra/2017-10-Paired-Text.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/18/Screenshot%202021-02-18%20at%204.09.54%20PM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/18/Screenshot%202021-02-18%20at%204.09.54%20PM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cklcdujmn0001445yq5j66zom",
    display_date: "2021-08-25",
    title: "T-Chart",
    url: "https://media.newsela.com/article_media/extra/2017-10-T-Chart.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2021/02/19/Screenshot%202021-02-19%20at%209.23.08%20AM.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2021/02/19/Screenshot%202021-02-19%20at%209.23.08%20AM.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cl3lr76u700023e6a72l617gg",
    display_date: "2022-05-27",
    title: "Reflect and Respond",
    url: "https://media.newsela.com/article_media/extra/2018-2-Reflect-Respond.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2022/05/25/screen-shot-2022-05-25-at-10-42-03-am-eea70tc6.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2022/05/25/screen-shot-2022-05-25-at-10-42-03-am-eea70tc6.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cl3lr7aqv00033e6aw2grr2vd",
    display_date: "2022-05-27",
    title: "Draw with Writing",
    url: "https://media.newsela.com/article_media/extra/Draw_with_Writing.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2022/05/25/screen-shot-2022-05-25-at-10-43-52-am-vsa90tla.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2022/05/25/screen-shot-2022-05-25-at-10-43-52-am-vsa90tla.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cl3ojhvqz00093f6b9h8h7q81",
    display_date: "2022-06-03",
    title: "Endangered Species Research",
    url: "https://media.newsela.com/article_media/extra/EndangeredSpeciesResearchNotes.docx.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2022/05/27/screen-shot-2022-05-27-at-9-29-37-am-w413cx0nid.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2022/05/27/screen-shot-2022-05-27-at-9-29-37-am-w413cx0nid.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cl3ym02g000053f6b4nwvcmqz",
    display_date: "2022-06-10",
    title: "Notice, Wonder, Connect",
    url: "https://media.newsela.com/article_media/extra/4.18.18.NoticeWonderConnect.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2022/06/03/screen-shot-2022-06-03-at-10-38-18-am-1zc3g08ya.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2022/06/03/screen-shot-2022-06-03-at-10-38-18-am-1zc3g08ya.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cl4ctsfq300053f6bdohvcmns",
    display_date: "2022-06-17",
    title: "Think-Puzzle-Explore",
    url: "https://media.newsela.com/article_media/extra/Think-Puzzle-Explore.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2022/06/13/screen-shot-2022-06-13-at-9-24-16-am-092b003nv.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2022/06/13/screen-shot-2022-06-13-at-9-24-16-am-092b003nv.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cl4ctunwb00093f6btfzba17q",
    display_date: "2022-06-17",
    title: "Problem-Solution",
    url: "https://media.newsela.com/article_media/extra/4.18.18.Problem-SolutionGraphicOrganizer.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2022/06/13/screen-shot-2022-06-13-at-9-25-47-am-h43wr08qf.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2022/06/13/screen-shot-2022-06-13-at-9-25-47-am-h43wr08qf.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cl4ctzdso00023f6bsg3j7a5p",
    display_date: "2022-06-17",
    title: "Letter Organizer",
    url: "https://media.newsela.com/article_media/extra/Part_of_a_Letter_Organizer_for_Reading_Writing_for_Change.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2022/06/13/screen-shot-2022-06-13-at-9-29-22-am-k54ne0ouf.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2022/06/13/screen-shot-2022-06-13-at-9-29-22-am-k54ne0ouf.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cllxrdf7z000w3b6bfi19o9n4",
    display_date: "2023-08-31",
    title: "Evidence Conclusion",
    url: "https://media.newsela.com/article_media/extra/5.1.18_Evidence_Conclusion.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-9-19-44-am-64dm0xs4.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-9-19-44-am-64dm0xs4.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cllxrdgk0001c3b6btfqcywkm",
    display_date: "2023-08-31",
    title: "Write a Comic",
    url: "https://media.newsela.com/article_media/extra/4.10.18_Write_A_Comic.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-9-21-50-am-7iex0svn.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-9-21-50-am-7iex0svn.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cllxrdgqv001g3b6b0vrvm1pv",
    display_date: "2023-08-31",
    title: "Commercial Planning",
    url: "https://media.newsela.com/article_media/extra/Commercial_Planning.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-9-22-24-am-4ef00zom.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-9-22-24-am-4ef00zom.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cllxrdgw4001k3b6btfjvr6c2",
    display_date: "2023-08-31",
    title: "There\u2019s an App for That!",
    url: "https://media.newsela.com/article_media/extra/Commercial_Planning.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-9-23-17-am-4qfx0ztz.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-9-23-17-am-4qfx0ztz.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cllxrdhi700233b6b7ukbdtul",
    display_date: "2023-08-31",
    title: "Teach and Learn",
    url: "https://media.newsela.com/article_media/extra/5.15.18_Teach_and_Learn.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-9-24-54-am-yih00t8s.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-9-24-54-am-yih00t8s.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cllxt12lc00fx3b6byn4b4czu",
    display_date: "2023-08-31",
    title: "Write a Recipe",
    url: "https://media.newsela.com/article_media/extra/5.11.18_Write_A_Recipe.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-9-58-13-am-yayt01we.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-9-58-13-am-yayt01we.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cllxt134p00g43b6bbl6pjqjt",
    display_date: "2023-08-31",
    title: "Help Wanted Advertisement Organizer",
    url: "https://media.newsela.com/article_media/extra/HelpWantedAdvertisementGraphicOrganizer.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-10-03-32-am-hh1280aa1.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-10-03-32-am-hh1280aa1.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cllxt13po00gb3b6b59iknptw",
    display_date: "2023-08-31",
    title: "Jigsaw (group of four)",
    url: "https://media.newsela.com/article_media/extra/NewselaJigsaw2.1.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-10-10-33-am-o81400x62.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-10-10-33-am-o81400x62.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cllxt13sd00gc3b6bvfuh7wre",
    display_date: "2023-08-31",
    title: "Triad Jigsaw",
    url: "https://media.newsela.com/article_media/extra/JigsawTriadActivity2020-02-25-00-58-44.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-10-11-58-am-4914v0sb0.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-10-11-58-am-4914v0sb0.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cllxt148p00gh3b6bi7diskzs",
    display_date: "2023-08-31",
    title: "Cause and Effect (with examples)",
    url: "https://media.newsela.com/article_media/extra/2017-11-2Newsela-Cause-Effect-Chart.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-10-06-57-am-671200x1c.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-10-06-57-am-671200x1c.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cllxt8dqi00jh3b6b7rsfa2pk",
    display_date: "2023-08-31",
    title: "Public Service Announcement Organizer",
    url: "https://media.newsela.com/article_media/extra/NewselaPSAWorksheet.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-10-03-32-am-1i17w0tge.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-10-03-32-am-1i17w0tge.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cllxtwqcz000a3b6b7d3tgpus",
    display_date: "2023-08-31",
    title: "RACE Writing Strategy",
    url: "https://media.newsela.com/article_media/extra/RACEWritingStrategy.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-10-27-53-am-0d1fr0th6.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-10-27-53-am-0d1fr0th6.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cllxua3im00ae3b6bdggbdjj8",
    display_date: "2023-08-31",
    title: "Headlines",
    url: "https://media.newsela.com/article_media/extra/Headlines.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-10-35-52-am-jt39k0vl5.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-10-35-52-am-jt39k0vl5.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "clly50f5k00ce3b6bbsbado99",
    display_date: "2023-08-31",
    title: "3-2-1 Bridge",
    url: "https://media.newsela.com/article_media/extra/3-2-1Bridge.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-3-36-27-pm-zn46o0se6.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-3-36-27-pm-zn46o0se6.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "clly58esn00gv3b6boi0a02y7",
    display_date: "2023-08-31",
    title: "Give One, Get One",
    url: "https://media.newsela.com/article_media/extra/10_19_Give_One_Get_One.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-3-45-51-pm-ac3sk0oh7.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2023/08/30/screenshot-2023-08-30-at-3-45-51-pm-ac3sk0oh7.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cllzfyb6k02453b6bffu9o1kp",
    display_date: "2023-08-31",
    title: "Cause and Effect",
    url: "https://media.newsela.com/article_media/extra/2017-12-Cause-Effect-Tchart.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2023/08/31/screenshot-2023-08-31-at-1-40-04-pm-5p4cp09qn.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2023/08/31/screenshot-2023-08-31-at-1-40-04-pm-5p4cp09qn.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "clm99ahcq000f3b6ba6vxayjc",
    display_date: "2023-09-07",
    title: "Central Idea Notetaker ",
    url: "https://prod-newsela-media.s3.amazonaws.com/article_media/extra/Central_Idea_Notetaker_-_Make_a_Copy_1.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2023/09/07/screenshot-2023-09-07-at-10-41-32-am-om4cli0oxc.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2023/09/07/screenshot-2023-09-07-at-10-41-32-am-om4cli0oxc.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "clm99ahvu000k3b6b5i21cgj9",
    display_date: "2023-09-07",
    title: "Key Terms Chart",
    url: "https://media.newsela.com/article_media/extra/Key_Terms_Chart__.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2023/09/07/screenshot-2023-09-07-at-10-49-55-am-8f47e809ll.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2023/09/07/screenshot-2023-09-07-at-10-49-55-am-8f47e809ll.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "clm9cnsap00fj3b6bk20cuyyv",
    display_date: "2023-09-07",
    title: "Primary Source Analysis",
    url: "https://media.newsela.com/article_media/extra/PrimarySourceAnalysis2020-02-25-01-05-54.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2024/04/11/screenshot-2024-04-11-at-4-37-55-pm-l81pdk0qvg.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2024/04/11/screenshot-2024-04-11-at-4-37-55-pm-l81pdk0qvg.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cluvr49i5000p3b6dwqn3dcwg",
    display_date: "2024-04-11",
    title: "ADAMANT Method",
    url: "https://media.newsela.com/article_media/extra/ADAMANT_Method.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2024/04/11/screenshot-2024-04-11-at-4-29-36-pm-zu1poq0zmd.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2024/04/11/screenshot-2024-04-11-at-4-29-36-pm-zu1poq0zmd.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cluvr99dk002r3b6ddwv0f3wl",
    display_date: "2024-04-11",
    title: "Summarizing",
    url: "https://media.newsela.com/article_media/extra/Summarizing_-_worksheet.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2024/04/11/screenshot-2024-04-11-at-4-32-45-pm-fv1qfz0n3d.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2024/04/11/screenshot-2024-04-11-at-4-32-45-pm-fv1qfz0n3d.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cluvrde8b004i3b6d23tjv0yf",
    display_date: "2024-04-11",
    title: "Structure and Purpose",
    url: "https://media.newsela.com/article_media/extra/StructureandPurpose.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2024/04/11/screenshot-2024-04-11-at-4-36-42-pm-k71psc0zvh.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2024/04/11/screenshot-2024-04-11-at-4-36-42-pm-k71psc0zvh.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cluvrhyt700713b6durqruj1d",
    display_date: "2024-04-11",
    title: "Paired Text Perspective Analysis",
    url: "https://media.newsela.com/article_media/extra/Paired_Text_Perspective_Analysis_.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2024/04/11/screenshot-2024-04-11-at-4-39-26-pm-py1pu40zn0.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2024/04/11/screenshot-2024-04-11-at-4-39-26-pm-py1pu40zn0.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cluvrkp85008t3b6dwtyce8sw",
    display_date: "2024-04-11",
    title: "Media Literacy: Image Analysis",
    url: "https://media.newsela.com/article_media/extra/4.30.2018.MediaLiteracyImageAnalysis.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2024/04/11/screenshot-2024-04-11-at-4-41-48-pm-671qp50fvm.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2024/04/11/screenshot-2024-04-11-at-4-41-48-pm-671qp50fvm.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cluvrmfof00a63b6dpmxrovcp",
    display_date: "2024-04-11",
    title: "Main Idea and Details Organizer",
    url: "https://media.newsela.com/article_media/extra/07_22_19_MainIdeaGraphicorganizer.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2024/04/11/screenshot-2024-04-11-at-4-43-30-pm-u11qlz0psi.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2024/04/11/screenshot-2024-04-11-at-4-43-30-pm-u11qlz0psi.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cluvrpudg00by3b6d0tj5pm7u",
    display_date: "2024-04-11",
    title: "Comparing Themes Across Texts",
    url: "https://media.newsela.com/article_media/extra/Comparing_Themes_Across_Texts_-_worksheet.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2024/04/11/screenshot-2024-04-11-at-4-46-08-pm-4s1p6s0hqc.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2024/04/11/screenshot-2024-04-11-at-4-46-08-pm-4s1p6s0hqc.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "cluvrpuuj00c33b6dfz0n2oa8",
    display_date: "2024-04-11",
    title: "Unit Vocabulary",
    url: "https://media.newsela.com/article_media/extra/2017-10-Vocabulary-Worksheet.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2024/04/11/screenshot-2024-04-11-at-4-47-04-pm-wn1qga0vnp.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2024/04/11/screenshot-2024-04-11-at-4-47-04-pm-wn1qga0vnp.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "clwgkydam00083b6e97e5licj",
    display_date: "2024-05-21",
    title: "Pro/Con Analysis",
    url: "https://media.newsela.com/article_media/extra/PRO3ACONanalysis.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2024/05/21/screenshot-2024-05-21-at-9-00-16-am-qhduq0aud.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2024/05/21/screenshot-2024-05-21-at-9-00-16-am-qhduq0aud.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "clwgkydkx000b3b6e3rre7fkf",
    display_date: "2024-05-21",
    title: "Let\u2019s Debate",
    url: "https://media.newsela.com/article_media/extra/5.5.18_Debate.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2024/05/21/screenshot-2024-05-21-at-9-04-14-am-vadr60u2o.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2024/05/21/screenshot-2024-05-21-at-9-04-14-am-vadr60u2o.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "clwgl6bn1004r3b6emut0axvk",
    display_date: "2024-05-21",
    title: "Opinion Response with Counterclaim",
    url: "https://media.newsela.com/article_media/extra/Opinion_Response_with_Counterclaim.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2024/05/21/screenshot-2024-05-21-at-9-08-49-am-4ydva0wk6.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2024/05/21/screenshot-2024-05-21-at-9-08-49-am-4ydva0wk6.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "clwgl6bty004t3b6ep8wx5j8m",
    display_date: "2024-05-21",
    title: "Argumentative Writing Closure Questions",
    url: "https://media.newsela.com/article_media/extra/Argumentative_Writing_Closure_Questions.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2024/05/21/screenshot-2024-05-21-at-9-11-06-am-71dvu0s6f.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2024/05/21/screenshot-2024-05-21-at-9-11-06-am-71dvu0s6f.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
  {
    id: "clwgl6bzg004u3b6egzj1o1b2",
    display_date: "2024-05-21",
    title: "Argumentative Essay Organizer",
    url: "https://media.newsela.com/article_media/extra/Argumentative_Essay_Organizer.pdf",
    description: "",
    images: [
      {
        generated_date: "2025-05-06T16:51:08.988Z",
        id: null,
        url: "https://newsela.imgix.net/alexandria/external-link/2024/05/21/screenshot-2024-05-21-at-9-07-17-am-7wdsy0uk8.png",
        formatted_url:
          "https://newsela.imgix.net/alexandria/external-link/2024/05/21/screenshot-2024-05-21-at-9-07-17-am-7wdsy0uk8.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=768&w=1366",
      },
    ],
    metadata: {
      content_type: "WORKSHEET",
    },
    viewmodel_type: "card",
  },
];
